import { Providers } from '../../../../enums/providers';
import { todoCardIds } from '../../../../pages/home-page/version2/todo-cards/todo-card-ids';
import { CountryConfigNames } from '../../country-config-enums';
import { CountryUIFeature } from '../country-ui-feature';
import { CountryUIConfigName } from '../constants';

export const AUCountryUIConfig = [
  new CountryUIFeature(CountryConfigNames.PreferredWalletedProvidersIds, {
    labelProvidersIds: [Providers.AustraliaPostMyPostBusinessWalleted.labelProviderId],
  }),
  new CountryUIFeature(CountryConfigNames.FTUWizardHiddenTodoCards, {
    todoCardIds: [todoCardIds.GET_STARTED_WEBINAR, todoCardIds.ACCOUNT_OPTIMIZATION_WEBINAR],
  }),
  new CountryUIFeature(CountryConfigNames.RateBrowserDefaults, {
    cityOrSuburb: 'Melbourne',
    postalCode: '3000',
    length: 10,
    width: 10,
    height: 10,
  }),
  new CountryUIFeature(CountryConfigNames.RequiresWalletForRateBrowser),
  // TODO: [SPD-26173] Remove once enableExpandedTaxIdCountries is fully rolled out
  new CountryUIFeature(CountryUIConfigName.TaxIdUIOverride, {
    isVisibleForPaymentFlow: 'false',
    showIssuingAuthorityList: 'false',
    invoiceAddressRequired: 'false',
  }),
];
